export default {
  lang_chooser: {
    aria_label: 'Language Chooser',
    lang_switch: 'Naviguer en',
  },
};
